export default {
  "customerLookup": {
    "title": "按团队 ID 查询",
    "teamId": "团队 ID",
    "placeholder": "请输入团队 ID",
    "open": "查看详情",
    "cancel": "取消",
    "invalid": "请输入有效的团队 ID（1～9223372036854775807）",
    "loading": "正在获取客户信息…",
    "invalidTitle": "团队 ID 无效",
    "invalidDescription": "请返回客户列表，核对团队 ID 后重新查询。",
    "emptyTitle": "未找到客户",
    "emptyDescription": "请返回客户列表，确认团队 ID 是否正确。",
    "unavailableTitle": "暂时无法获取客户信息",
    "unavailableDescription": "请稍后重试；如登录已失效，请重新登录。",
    "retry": "重试"
  }
};
